import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  ApiService,
  Region,
} from "@core/services/api/api.service";
import { AuditPermissionService } from "@core/services/audit-permission.service";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";
import { ModalComponent } from "@shared/components/modal/modal.component";

@Component({
  selector: "app-add-product-family",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimeNGSharedModule,
    ModalComponent,
    ToastMessageComponent,
  ],
  templateUrl: "./add-product-family.component.html",
  styleUrl: "./add-product-family.component.scss",
})
export class AddProductFamilyComponent {
  @Input() visible: boolean = false;
  @Input() editMode: boolean = false;
  @Input() data: any;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  permissionPop: boolean = false;
  @ViewChild(ToastMessageComponent) toast!: ToastMessageComponent;

  category: Region[] = [];
  productFamilyForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private auditService: AuditPermissionService
  ) {
    this.initializeForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.editMode) {
      this.productFamilyForm.patchValue({
        name: this.data.name,
      });
    }
  }
  ngOnInit(): void {}
  initializeForm(): void {
    this.productFamilyForm = this.fb.group({
      name: [null, Validators.required],
    });
  }
  close() {
    this.closeDialog.emit();
    this.permissionPop = false;
    this.productFamilyForm.reset();
  }
  add() {
    const formValue = this.productFamilyForm.value;
    const payload = {
      name: formValue.name,
    };
    this.auditService.addProductFamily(payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.productFamilyForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  update() {
    const formValue = this.productFamilyForm.value;
    const payload = {
      name: formValue.name,
    };
    this.auditService.updateProductFamily(this.data.id, payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.productFamilyForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  onSubmit() {
    this.permissionPop = true;
  }

  onSubmitPermission(event: any) {
    if (this.editMode) {
      this.update();
    } else {
      this.add();
    }

    this.permissionPop = false;
  }
  onCancelPermission(event: any) {
    this.permissionPop = false;
  }
}
